<template>
  <div class="problem-image-item">
    <img v-for="data in itemPictures" :src="data.data" alt="" @click="$emit('pictureClick', data)"/>
  </div>
</template>

<script>


export default {
  name: 'ProblemImageItem',
  props: ['problem'],
  data: function() {
    return {
      itemPictures: []
    }
  },
  mounted: function() {
    var self = this;
    self.App.post("/server/problems/getPictures.php", {id: self.problem.id}, function(d) {
      if (d == "0") {
        return;
      }
      self.itemPictures = d;
    });
  }
};
</script>
